// removed by extract-text-webpack-plugin
module.exports = {"select-items-button":"select-items-button","item-names":"item-names","no-items":"no-items","select-button":"select-button","disabled":"disabled"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/SelectItems.scss
// module id = zJYP
// module chunks = 0